import React from 'react';

const Terms: React.FC = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1>Terms of Service</h1>
        <p style={styles.updated}>Last Updated: February 11, 2026</p>

        <section style={styles.section}>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using QuoteBid ("Service"), operated by L Benoit Enterprises LLC DBA QuoteBid,
            you agree to be bound by these Terms of Service. If you do not agree to these terms,
            please do not use our Service.
          </p>
        </section>

        <section style={styles.section}>
          <h2>2. Description of Service</h2>
          <p>
            QuoteBid is an online marketplace that connects customers seeking products or services
            with businesses who can provide them. Customers post quote requests, and registered
            businesses submit competitive quotes.
          </p>
        </section>

        <section style={styles.section}>
          <h2>3. User Accounts</h2>
          <p>
            To use certain features of the Service, you must register for an account. You agree to:
          </p>
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Notify us immediately of any unauthorized access</li>
            <li>Accept responsibility for all activities under your account</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>4. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any unlawful purpose</li>
            <li>Post false, misleading, or fraudulent content</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Interfere with the proper functioning of the Service</li>
            <li>Attempt to gain unauthorized access to our systems</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>5. Business Subscriptions</h2>
          <p>
            Businesses may subscribe to paid plans (Pro or Premium) for additional features.
            Subscription fees are billed monthly and are non-refundable. You may cancel your
            subscription at any time, and it will remain active until the end of the billing period.
          </p>
        </section>

        <section style={styles.section}>
          <h2>6. SMS/Text Notifications</h2>
          <p>
            By providing your phone number during registration, you consent to receive transactional
            SMS notifications from QuoteBid regarding your account activity, including new quote
            requests, quote submissions, and quote acceptances. Message frequency varies based on
            your marketplace activity. Message and data rates may apply.
          </p>
          <p>
            You may opt out of SMS notifications at any time by replying STOP to any message.
            For help, reply HELP or contact support@quotebid.io. Opting out of SMS notifications
            will not affect your ability to use the QuoteBid platform.
          </p>
        </section>

        <section style={styles.section}>
          <h2>7. Quotes and Transactions</h2>
          <p>
            QuoteBid facilitates connections between customers and businesses but is not a party
            to any transaction between them. We do not guarantee the quality, safety, or legality
            of services offered by businesses. Users are responsible for conducting their own
            due diligence.
          </p>
        </section>

        <section style={styles.section}>
          <h2>8. Intellectual Property</h2>
          <p>
            The QuoteBid name, logo, and all related content are the property of L Benoit
            Enterprises LLC. You may not use our trademarks without prior written consent.
          </p>
        </section>

        <section style={styles.section}>
          <h2>9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, QuoteBid and L Benoit Enterprises LLC shall
            not be liable for any indirect, incidental, special, consequential, or punitive damages
            arising from your use of the Service.
          </p>
        </section>

        <section style={styles.section}>
          <h2>10. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless L Benoit Enterprises LLC, its officers,
            directors, employees, and agents from any claims, damages, or expenses arising from
            your use of the Service or violation of these Terms.
          </p>
        </section>

        <section style={styles.section}>
          <h2>11. Modifications</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of
            significant changes via email or through the Service. Continued use after changes
            constitutes acceptance of the new Terms.
          </p>
        </section>

        <section style={styles.section}>
          <h2>12. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of the State of Louisiana, without regard
            to its conflict of law provisions.
          </p>
        </section>

        <section style={styles.section}>
          <h2>13. Contact Information</h2>
          <p>
            For questions about these Terms, please contact us at:<br />
            <strong>Email:</strong> support@quotebid.io<br />
            <strong>Address:</strong> 33310 Beverly Dr, Denham Springs, LA 70706
          </p>
        </section>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: '40px 20px',
    maxWidth: '800px',
    margin: '0 auto',
  },
  content: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  updated: {
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginBottom: '30px',
  },
  section: {
    marginBottom: '30px',
  },
};

export default Terms;